import styled from 'styled-components';

export const ReportItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 50px 0;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 0;
  }
`;

export const Divider = styled.span`
  border-bottom: solid 1px ${({ theme }) => theme.travelReport.separator};
  height: 100%;
  margin: 18px 0 12px 0;
`;

export const ReportValueBudget = styled.div`
  display: flex;
`;

export const ReportValueTitle = styled.h5`
  font-weight: bold;
  color: ${({ theme }) => theme.travelReport.color};
`;

export const ReportSubItem = styled.span`
  font-size: 12px;
  margin-left: auto;
`;

export const ReportValueText = styled.span`
  font-size: 20px;
`;
